import { defineMessages } from '@transcend-io/internationalization';

export const customFunctionMessages = defineMessages(
  'ad-core-components.CustomFunction.customFunction',
  {
    titleCreate: {
      defaultMessage: 'Create Custom Function',
    },
    titleUpdate: {
      defaultMessage: 'Update Custom Function',
    },
    titleLoading: {
      defaultMessage: 'Loading...',
    },
    discardAll: {
      defaultMessage: 'Discard All Changes',
    },
    saveAll: {
      defaultMessage: 'Publish Custom Function',
    },
    tabCodeEditor: {
      defaultMessage: 'Code Editor',
    },
    tabEnvironmentVariables: {
      defaultMessage: 'Environment Variables',
    },
    tabTesting: {
      defaultMessage: 'Testing',
    },
    deno: {
      defaultMessage: 'Deno',
    },
    importThirdPartyDeps: {
      defaultMessage: 'this import syntax',
    },
    denoPermissions: {
      defaultMessage: 'Deno permissions documentation',
    },
    codeEditorInstructions: {
      defaultMessage:
        'Write TypeScript or JavaScript code, which can be executed on Sombra in a {Deno} sandbox.' +
        ' Import third-party modules with {ImportThirdPartyDeps}.' +
        ' You do not have file system access, or anything listed in the {DenoPermissions} except for network access.' +
        ' Environment variables and secrets are passed through the {Environment} argument.',
    },
    environmentVariablesInstructions: {
      defaultMessage:
        'Environment variables are passed to the function as a map of key-value pairs. ' +
        'You can use them in your code by accessing the {Environment} argument.',
    },
    testingInstructions: {
      defaultMessage:
        'Set a test input and trigger your Custom Function. ' +
        'The test input corresponds to the function argument received by your Custom Function. ' +
        'The {Environment} object uses template variables to reference the values set in Environment Variables, ' +
        'but you can overwrite them for testing purposes in this object by changing the value to a hardcoded string.',
    },
    testRunSuccessTitle: {
      defaultMessage: 'Test run successful',
    },
    testRunErrorTitle: {
      defaultMessage: 'Test run failed',
    },
    testRunValidationErrorTitle: {
      defaultMessage: 'Test was unable to start',
    },
    testRunPendingTitle: {
      defaultMessage: 'Test running',
    },
    testRunSuccessMessage: {
      defaultMessage: 'The test run was successful.',
    },
    testRunServerErrorMessage: {
      defaultMessage: 'Transcend encountered an unexpected error.',
    },
    testRunFunctionErrorMessage: {
      defaultMessage: 'Your Custom Function encountered an error.',
    },
    testRunValidationErrorMessage: {
      defaultMessage: 'The test payload is invalid.',
    },
    testRunPendingMessage: {
      defaultMessage: 'The test run is running...',
    },
    testRunLogsHeaderCustomFunction: {
      defaultMessage: 'View the test run logs from your Custom Function',
    },
    testRunLogsHeaderSombraError: {
      defaultMessage: 'View the error log from the Sombra service',
    },
    testRunLogsHeaderGeneralError: {
      defaultMessage: 'View the error log',
    },
    versionHistory: {
      defaultMessage: 'Version History',
    },
    addEnvironmentVariable: {
      defaultMessage: 'Add Environment Variable',
    },
    environmentVariableName: {
      defaultMessage: 'Environment Variable Name',
    },
    environmentVariableValue: {
      defaultMessage: 'Environment Variable Value',
    },
    sendTestRequest: {
      defaultMessage: 'Send Test Request',
    },
    resetTestPayload: {
      defaultMessage: 'Reset Test Payload to Default',
    },
    functionExecutedIn: {
      defaultMessage: 'Custom Function executed in {duration}',
    },
    exitCode: {
      defaultMessage:
        'Custom Function exited after {duration} with exit code {exitCode}.',
    },
  },
);
